var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './style.module.scss';
import { Button, Loader, Select } from '../index';
import { useHttp } from '../../hooks/useHttp';
const ModalUpdate2 = ({ hideModal, loaderModal2, disciplineOne, updateTeacher, formSelect, groups, credit, idSemester, }) => {
    var _a;
    const { request } = useHttp();
    const { t } = useTranslation();
    const [kafedra, setKafedra] = React.useState([]);
    const [flows, setFlows] = React.useState([]);
    const [teachers, setTeachers] = React.useState([]);
    const [value, setValues] = React.useState({
        kafedra: '',
        teacher: '',
        flow: '',
    });
    React.useEffect(() => {
        var _a, _b, _c, _d;
        if (disciplineOne.length) {
            setValues({
                kafedra: (_a = disciplineOne[0]) === null || _a === void 0 ? void 0 : _a.id_kafedra,
                teacher: (_b = disciplineOne[0]) === null || _b === void 0 ? void 0 : _b.id_teacher,
                flow: (_c = disciplineOne[0]) === null || _c === void 0 ? void 0 : _c.subGroup,
            });
            getFlows2((_d = disciplineOne[0]) === null || _d === void 0 ? void 0 : _d.id_teacher, formSelect.kafedra);
        }
    }, [disciplineOne]);
    React.useEffect(() => {
        getTeachers(formSelect.kafedra);
        getKafedra();
    }, []);
    const changeKafedra = (e) => {
        setValues(Object.assign(Object.assign({}, value), { kafedra: e.target.value }));
        if (teachers.length) {
            setTeachers([]);
        }
        getTeachers(e.target.value);
        if (flows.length) {
            setFlows([]);
        }
    };
    const changeTeacher = (e) => {
        setValues(Object.assign(Object.assign({}, value), { teacher: e.target.value, flow: '' }));
        getFlows2(e.target.value, value.kafedra);
    };
    const changeFlow = (e) => setValues(Object.assign(Object.assign({}, value), { flow: e.target.value }));
    const getTeachers = (id_kafedra) => __awaiter(void 0, void 0, void 0, function* () {
        const group = groups.find((item) => item.id_group == Number(formSelect.group));
        const { data } = yield request(`/teacher-for-update?id_year=${formSelect.year}&id_kafedra=${id_kafedra}&id_w_s=${formSelect.ws}&id_semester=${idSemester}&id_faculty=${formSelect.faculty}&id_discipline=${formSelect.discipline}&id_f_educ=${group === null || group === void 0 ? void 0 : group.id_f_educ}&kredit=${credit}`);
        setTeachers(data);
    });
    const getKafedra = () => __awaiter(void 0, void 0, void 0, function* () {
        const group = groups.find((item) => item.id_group == Number(formSelect.group));
        const { data } = yield request(`/re-kafedra?id_year=${formSelect.year}&id_w_s=${formSelect.ws}&id_faculty=${formSelect.faculty}&id_discipline=${formSelect.discipline}&id_f_educ=${group === null || group === void 0 ? void 0 : group.id_f_educ}&kredit=${credit}&id_examination=${formSelect.formControl}`);
        setKafedra(data);
    });
    const getFlows2 = (id_teacher, kafedra) => __awaiter(void 0, void 0, void 0, function* () {
        setFlows([]);
        const group = groups.find((item) => item.id_group == Number(formSelect.group));
        const { data } = yield request(`/flow2?id_discipline=${formSelect.discipline}&id_year=${formSelect.year}&id_examination=${formSelect.formControl}&id_w_s=${formSelect.ws}&id_kafedra=${kafedra}&id_teacher=${id_teacher}&id_o_z=${group === null || group === void 0 ? void 0 : group.o_z}&id_f_educ=${group === null || group === void 0 ? void 0 : group.id_f_educ}&kredit=${credit}&id_faculty=${formSelect.faculty}`);
        // setValues({ ...value, flow: data[0]?.subgroup })
        setFlows(data);
    });
    return (_jsx("div", Object.assign({ className: styles.container }, { children: _jsxs("div", Object.assign({ className: styles.modal }, { children: [_jsxs("div", Object.assign({ className: styles.head }, { children: [_jsxs("h4", { children: [t('changeRegister'), ": ", _jsx("br", {}), _jsx("strong", Object.assign({ className: "text-primary" }, { children: (_a = disciplineOne[0]) === null || _a === void 0 ? void 0 : _a.discipline }))] }), _jsx("i", { className: "fa-solid fa-xmark", onClick: hideModal })] })), _jsx("div", Object.assign({ className: styles.body }, { children: loaderModal2 ? (_jsx("div", Object.assign({ className: "d-flex justify-content-center" }, { children: _jsx(Loader, { type: "text-primary" }) }))) : (_jsxs(_Fragment, { children: [_jsx(Select, { label: t('kafedra'), margin: "0px", width: "100%", name: "kafedra", defaultLabel: value.kafedra, change: changeKafedra, options: kafedra.map((item) => ({ value: item.id_kafedra, label: item.kafedra })) }), _jsx(Select, { label: t('teacher'), margin: "10px", width: "100%", name: "teacher", defaultLabel: value.teacher, options: teachers.map((item) => ({ value: item.id_teacher, label: item.t_fio })), change: changeTeacher }), _jsx(Select, { label: t('flow'), margin: "10px", width: "100%", name: "flow", 
                                // defaultTire={false}
                                defaultLabel: value.flow, options: flows.length
                                    ? flows.map((item) => ({ value: item.subgroup, label: item.subgroupAndName }))
                                    : [], change: changeFlow }), _jsx("div", Object.assign({ className: "d-flex justify-content-center mt-4" }, { children: _jsx(Button, { value: t('change'), style: { maxWidth: '200px' }, disabled: !value.flow, onClick: updateTeacher.bind(null, value.teacher, value.flow, value.kafedra), icon: _jsx("i", { className: "fa-solid fa-arrows-rotate" }) }) }))] })) }))] })) })));
};
export default ModalUpdate2;
